<template>
  <div class="card">
    <div class="card-header color-yellow">
      Obchody a pohyby na majetkovom účte
    </div>
    <div class="card-body trades-wrapper pt-3 pl-0 pr-0">
      <Loading v-if="loading" />
      <data-grid
        :items="items"
        :columns="columns"
        :on-detail-open="loadDetail"
        v-else
      >
        <template slot="amount" slot-scope="{ item }">
          <span
            :class="{
              'text-success': item.amount >= 0,
              'text-danger': item.amount < 0
            }"
          >
            {{ item.amount | number }}
          </span>
        </template>
        <template slot="value" slot-scope="{ item }">
          {{ item.value | number }}
        </template>
        <template slot="date" slot-scope="{ item }">
          {{ item.date | date }}
        </template>
        <template slot="price" slot-scope="{ item }">
          {{ item.price | number(null) }}
        </template>
        <template slot="amount" slot-scope="{ item }">
          {{ item.amount | number(null) }}
        </template>
        <template slot="detail" slot-scope="{ item }">
          <Loading v-if="!item.detail" class="mb-5 p-5" />
          <div class="pt-3 pb-3 details-wrapper" v-if="item.detail">
            <strong>Podrobnosti</strong>
            <div class="row">
              <div class="col-12 col-md-8 details-wrapper">
                <!--                <div class="row">-->
                <!--                  <div class="col-md-6">Poplatok za vysporiadanie:</div>-->
                <!--                  <div class="col-md-6">-->
                <!--                    {{ item.detail.settlementFee | number }} {{ item.currency }}-->
                <!--                  </div>-->
                <!--                </div>-->
                <!--                <div class="row">-->
                <!--                  <div class="col-md-6">Poplatok za obchod:</div>-->
                <!--                  <div class="col-md-6">-->
                <!--                    {{ item.detail.dealFee | number }} {{ item.currency }}-->
                <!--                  </div>-->
                <!--                </div>-->
                <!--                <div class="row">-->
                <!--                  <div class="col-md-6">Poplatok tretej strany:</div>-->
                <!--                  <div class="col-md-6">-->
                <!--                    {{ item.detail.partnerFee | number }} {{ item.currency }}-->
                <!--                  </div>-->
                <!--                </div>-->
                <!--              </div>-->
                <!--              <div class="col-12 col-md-4 details-wrapper">-->
                <div class="row">
                  <div class="col-md-3">Aktívum:</div>
                  <div class="col-md-9">{{ item.detail.equity }}</div>
                </div>
                <div class="row">
                  <div class="col-md-3">ISIN:</div>
                  <div class="col-md-9">{{ item.detail.isin }}</div>
                </div>
                <div class="row">
                  <div class="col-md-3">Typ aktíva:</div>
                  <div class="col-md-9">{{ item.detail.equityType }}</div>
                </div>
                <!--              </div>-->
                <!--              <div class="col-12 col-md-4 details-wrapper">-->
                <!--                <div class="row">-->
                <!--                  <div class="col-md-6">Dátum pohybu:</div>-->
                <!--                  <div class="col-md-6">{{ item.detail.date | date }}</div>-->
                <!--                </div>-->
                <!--                <div class="row">-->
                <!--                  <div class="col-md-6">Dátum vysporiadania:</div>-->
                <!--                  <div class="col-md-6">-->
                <!--                    {{ item.detail.settlementDate | date }}-->
                <!--                  </div>-->
                <!--                </div>-->
              </div>
            </div>
            <!--            <div class="text-center mt-4">-->
            <!--              <a class="detail-pdf" href=""-->
            <!--              ><font-awesome-icon icon="file-pdf"/></a-->
            <!--              >-->
            <!--            </div>-->
          </div>
        </template>
      </data-grid>
<!--      <Loading v-if="!loading && loadingNext" />-->
      <div class="mt-4 text-center" v-if="items.length % 10 === 0">
        <button type="button" class="btn btn-warning" @click="nextPage()">
          <span>Načítať ďalšie</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import DataGrid from "../../../components/DataGrid";
import Loading from "../../../components/Loading";

export default {
  name: "Trades",
  components: {
    DataGrid,
    Loading
  },
  // props: {
  //   portfolio: {
  //     type: String | null,
  //     required: false,
  //     default: null
  //   }
  // },
  watch: {
    portfolio() {
      this.page = 1;
      this.loadData();
    },
    from() {
      this.page = 1;
      this.loadData();
    },
    to() {
      this.page = 1;
      this.loadData();
    },
    valueFilter: {
      handler: function() {
        this.page = 1;
        this.loadData();
      },
      deep: true
    }
  },
  computed: {
    items() {
      return this.$store.state.transactions.trades;
    },
    portfolio() {
      return this.$store.state.portfolio.selected;
    },
    loading() {
      return this.$store.state.transactions.loading;
    },
    loadingNext() {
      return this.$store.state.transactions.loadingNext;
    },
    from() {
      return this.$store.state.transactions.from;
    },
    to() {
      return this.$store.state.transactions.to;
    },
    valueFilter() {
      return this.$store.state.transactions.transactionsValueFilter;
    }
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.$store.commit("transactions/resetTradeDetails");
      this.$store.dispatch("transactions/trades", {
        page: this.page,
        append: this.append,
        investmentStrategyId: this.portfolio,
        from: this.from,
        to: this.to,
        valueFrom: this.valueFilter.from === "" ? null : this.valueFilter.from,
        valueTo: this.valueFilter.to === "" ? null : this.valueFilter.to
      });
    },
    loadDetail(trade, index) {
      this.$store.dispatch("transactions/tradeDetail", {
        id: trade.id,
        index
      });
    },
    nextPage() {
      this.page += 1;
      this.append = true;
      this.loadData();
      this.append = false;
    }
  },
  data() {
    return {
      page: 1,
      append: false,
      columns: [
        {
          name: "Dátum pohybu",
          slug: "date"
        },
        {
          name: "Portfólio",
          slug: "portfolio"
        },
        {
          name: "Typ pohybu",
          slug: "tradeType"
        },
        {
          name: "Aktívum",
          slug: "asset"
        },
        {
          name: "Počet",
          slug: "amount"
        },
        {
          name: "Cena",
          slug: "value"
        },
        // {
        //   name: "Objem",
        //   slug: "price"
        // },
        {
          name: "Mena",
          slug: "currency"
        }
      ]
    };
  }
};
</script>

<style lang="scss">
.trades-wrapper table {
  font-size: 13px !important;

  strong {
    font-size: 14px;
  }

  @include media-breakpoint-down(lg) {
    font-size: 11px !important;
  }
}
</style>
